// 세션 keep-alive(SessionKeepAliveSentinel) 활성 라우트 화이트리스트 (DDAT-1660 — KR DDAT-104/1658 포트).
// 여기 있는 라우트에서는 30분 주기 선제 토큰 갱신으로 자동 로그아웃(60분 유휴)이 발생하지 않는다.
// 라우트명은 router.js 의 name 과 동기화한다. 신규 맵 화면 라우트 추가 시 이 목록에도 추가할 것.
export const SESSION_KEEP_ALIVE_ROUTE_NAMES = new Set([
	// 맵박스(Mapbox.vue) 렌더 화면 — 관제·전시 용도로 장시간 표시
	'dashBoard', // 대시보드 (/dash)
	'vehicleSttsMng', // 차량 현황 (/status)
	'report', // 고장 접수 (/breakdown)
	'sosCall', // SOS (/sos)
]);
